import { ClearSaleReliabilityList } from '~/typings/enums/ClearSale';

export const getReliability = (score: number) => {
  const parsedScore = Math.floor(score);
  return ClearSaleReliabilityList.find((el) => parsedScore >= el.min && parsedScore <= el.max);
};

export const CLEAR_SALE_2FA_COLORS = {
  green: '#52b771',
  yellow: '#f1c40f',
  red: '#c0392b',
};

/**
 * Cor do score ClearSale 2FA de acordo com o risco:
 * - <= 46        -> verde (baixo risco)
 * - > 46 e < 80  -> amarelo (risco médio)
 * - >= 80        -> vermelho (alto risco)
 */
export const get2faScoreColor = (score?: number | null): string | undefined => {
  if (score === undefined || score === null) return undefined;
  if (score >= 80) return CLEAR_SALE_2FA_COLORS.red;
  if (score > 46) return CLEAR_SALE_2FA_COLORS.yellow;
  return CLEAR_SALE_2FA_COLORS.green;
};
